module.exports = __webpack_public_path__ + "static/media/showmore.41626366.svg";